import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import moment from 'moment';

import * as actions from '../../actions/departamentos';
import {api} from '../../actions/_request';

const SubmitLoad = () => (
	<div className="p-2">
		<Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
	</div>
);

class ProspectoModal extends React.Component
{
	constructor(props)
	{
		super(props)
		this.state = {
			departamento: {
                id: null,
                nombre: "",
                meta: 0,
                comision: 0,
               
            
            },
            action: 'save',
        };

		this.handleChangeInput 		= this.handleChangeInput.bind(this);
		
		this.handleSubmit 			= this.handleSubmit.bind(this);
   
	}

	componentDidMount()
	{
		

		
       

       

	}

    componentWillReceiveProps(nextProps)
    {
        let {prospectoid} = nextProps;
        let self = this;

        if(prospectoid > 0 && prospectoid != self.state.departamento.id)
        {
            api().get(`/departamento/${prospectoid}`)
            .then(function(response)
            {
                if(response.status === 200)
                {
                   
                    self.setState({
                        departamento: response.data,
                        action: 'update'
                    });             
             }
            });


        }
        else if(prospectoid == null && self.state.departamento.id)
        {
            self.asNothing();
        }
    }

    asNothing()
    {
        this.setState({
          departamento: {
                id: null,
                nombre: "",
                meta: 0,
                comision: 0,
               
            
            },
            action: 'save',
        });
    }

	handleChangeInput(event)
	{
		const target 	= event.target;
		const value 	= target.type === 'checkbox' ? target.checked : target.value;
		const name 		= target.name;

		let {departamento} = this.state;
		departamento[name] = value;
		this.setState({departamento: departamento});
  

	}

	objeto_mayusculas(objeto){
         for (var key in objeto) {
                if (objeto.hasOwnProperty(key)) {
                    // var valor=String(objeto[key]).toUpperCase();                 
                    // console.log('valor---->',valor)
                     
                         objeto[key] = String(objeto[key]).toUpperCase() ;
                         if( String(objeto[key]).toUpperCase()==='NULL')
                            objeto[key] ='';
                     
                    // console.log(key + " = " + objeto[key]);
                }
              }
              return objeto;
    }
	
   
	handleSubmit(evt)
	{
		evt.preventDefault();
		let {departamento} = this.state;
		var self = this;
        //console.log(self.state.action);
		// post
        departamento=this.objeto_mayusculas(departamento);
		this.props[self.state.action](departamento, () => {

			swal({
				title: 'Departamento',
				text: "Se ha guardado con éxito",
				type: 'success',
				// showCancelButton: true,
				// confirmButtonColor: '#3085d6',
				// cancelButtonColor: '#d33',
				confirmButtonText: 'Continuar!'
			}).then((result) => {
				if (result.value) {
					// swal(
					// 	'Deleted!',
					// 	'Your file has been deleted.',
					// 	'success'
					// 	)
					self.props.toggle();
                    self.asNothing();
				}
			})

		});
	}

	render()
	{
		let {departamento} = this.state;

		return(

			<Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg">
				<form onSubmit={this.handleSubmit}>
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    
                    <div className="row">
                        <div className="col-sm-12">
                            <h6 className="mb-4 text-uppercase">Datos Personales</h6>
                        </div>
                    </div>

                    <div className="row">
                       
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label htmlFor="">Nombre</label>
                                <input 
                                 type="text" 
                                 name="nombre" 
                                 value={departamento.nombre}
                                 onChange={this.handleChangeInput} 
                                 className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label htmlFor="">Meta</label>
                                <input 
                                 type="number" 
                                 name="meta" 
                                 value={departamento.meta}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>

                         <div className="col-sm-4">
                            <div className="form-group">
                                <label htmlFor="">% Comision</label>
                                <input 
                                 type="number" 
                                 name="comision" 
                                 value={departamento.comision}
                                 onChange={this.handleChangeInput}
                                 className="form-control" />
                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    
                    	
                    	<div>
                    		<Button color="success" type="submit" type="submit">
                    			<IconSave />&nbsp;Guardar
                    		</Button>{' '}
                    		<Button color="danger" onClick={this.props.toggle}>
		                    	Cancelar
		                    </Button>
                    	</div>
                    
                </ModalFooter>
                </form>
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
          departamento: state.departamento,
        
    }
};

export default connect(mapStateToProps, actions)(ProspectoModal)



// WEBPACK FOOTER //
// ./src/views/departamentos/Modal.js